import Alert from '@mui/material/Alert';

type ErrorViewProps = {
  message: string;
};

const AlertDialog = ({ message }: ErrorViewProps) => {
  return <Alert severity="error">{message}</Alert>;
};

export default AlertDialog;
